
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Punetoashtavinayakdarshanurbania() {



    const cardData =
    {
        keyword: 'Pune to Ashtavinayak darshan Urbania Hire   ',
        heading: 'Amruta Travels: Pune to Ashtavinayak darshan Urbania Hire   ',
        headingDescription: 'Amruta Travels offers Pune to Ashtavinayak Darshan Urbania Hire, providing a comfortable and reliable travel solution for groups planning a pilgrimage to the eight famous Ganapati temples near Pune. Our 13-seater and 17-seater Force Urbania vans feature spacious interiors, air-conditioning, and modern amenities to ensure a smooth and enjoyable journey. With experienced drivers, punctual service, competitive pricing, and 24/7 support, Amruta Travels makes your Ashtavinayak Darshan trip safe, convenient, and stress-free.',


        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],



  "services": [
    {
      "name": "Pune to Ashtavinayak Darshan Urbania bus hire",
      "description": "Urbania bus hire from Pune to Ashtavinayak for group pilgrimages, comfortable AC travel, and safe journeys."
    },
    {
      "name": "Urbania bus hire for Ashtavinayak Darshan from Pune",
      "description": "Urbania bus service from Pune to Ashtavinayak temples for family, corporate, and group tours with professional drivers."
    },
    {
      "name": "Force Urbania bus Pune to Ashtavinayak",
      "description": "Force Urbania bus from Pune to Ashtavinayak for luxury travel, spacious seating, and AC comfort on pilgrimage trips."
    },
    {
      "name": "Urbania bus on rent Pune to Ashtavinayak Darshan",
      "description": "Urbania bus rental from Pune to Ashtavinayak for one-day or multi-day tours with flexible booking options."
    },
    {
      "name": "13 seater Urbania bus Pune to Ashtavinayak",
      "description": "13 seater Urbania bus for small group Ashtavinayak Darshan tours from Pune with comfortable seating and AC interiors."
    },
    {
      "name": "17 seater Urbania bus Pune to Ashtavinayak",
      "description": "17 seater Urbania bus for larger groups from Pune to Ashtavinayak Darshan with ample luggage space and smooth ride."
    },
    {
      "name": "Luxury Urbania bus for Ashtavinayak Darshan",
      "description": "Luxury Urbania bus for Ashtavinayak Darshan tours from Pune with elegant interiors, AC comfort, and professional drivers."
    },
    {
      "name": "AC Urbania bus Pune Ashtavinayak tour",
      "description": "AC Urbania bus for Ashtavinayak pilgrimage ensuring cool, comfortable travel on all days of the tour."
    },
    {
      "name": "Force Urbania 17 seater bus Ashtavinayak",
      "description": "Force Urbania 17 seater bus from Pune to Ashtavinayak for large groups, corporate pilgrimages, and family tours."
    },
    {
      "name": "Urbania bus hire for Ashtavinayak Yatra Pune",
      "description": "Urbania bus hire for Ashtavinayak Yatra from Pune for one-day or multi-day temple visits with experienced chauffeurs."
    },
    {
      "name": "Urbania bus rental Pune for Ganpati Darshan",
      "description": "Urbania bus rental from Pune for Ganpati Darshan and Ashtavinayak pilgrimage tours with AC comfort and spacious seating."
    },
    {
      "name": "Urbania bus Ashtavinayak pilgrimage tour",
      "description": "Urbania bus for Ashtavinayak pilgrimage tours from Pune covering all eight temples with reliable service and professional drivers."
    },
    {
      "name": "Urbania bus hire Pune for temple tour",
      "description": "Urbania bus hire from Pune for temple tours including Ashtavinayak Darshan with comfortable and safe travel."
    },
    {
      "name": "Urbania bus for senior citizen Ashtavinayak Darshan",
      "description": "Urbania bus specially arranged for senior citizens for Pune to Ashtavinayak Darshan with comfort and accessibility."
    },
    {
      "name": "Pune to Ashtavinayak Darshan bus package",
      "description": "Complete Pune to Ashtavinayak Darshan bus packages including one-day and multi-day trips with luxury AC buses."
    },
    {
      "name": "Pune Ashtavinayak 2 days Urbania bus",
      "description": "Two-day Urbania bus tour from Pune for Ashtavinayak Darshan covering major temples with spacious AC buses."
    },
    {
      "name": "Pune Ashtavinayak 3 days Urbania bus tour",
      "description": "Three-day Ashtavinayak Darshan Urbania bus tour from Pune with comfortable travel, hotel drop-offs, and temple visits."
    },
    {
      "name": "Ashtavinayak Darshan bus hire Pune itinerary",
      "description": "Urbania bus hire from Pune with customizable Ashtavinayak Darshan itinerary for group or family travel."
    },
    {
      "name": "Pune to all 8 Ganpati Darshan Urbania bus",
      "description": "Urbania bus from Pune covering all 8 Ganpati temples of Ashtavinayak for comprehensive pilgrimage tours."
    },
    {
      "name": "Ashtavinayak Darshan Urbania bus from Pune",
      "description": "Urbania bus service from Pune to Ashtavinayak Darshan with professional drivers, AC interiors, and comfortable seating."
    },
    {
      "name": "Book Urbania bus Pune to Ashtavinayak",
      "description": "Easy online booking of Urbania bus from Pune to Ashtavinayak temples with flexible dates and timings."
    },
    {
      "name": "Online Urbania bus booking Ashtavinayak",
      "description": "Online Urbania bus booking for Pune to Ashtavinayak pilgrimage tours with secure and hassle-free reservations."
    },
    {
      "name": "Urbania bus Pune Ashtavinayak contact number",
      "description": "Contact Urbania bus service for Pune to Ashtavinayak tours for inquiries, booking, and itinerary planning."
    },
    {
      "name": "13 Seater Urbania Bus Pune to Ashtavinayak Darshan",
      "description": "13 Seater Urbania bus from Pune for small groups visiting Ashtavinayak temples with comfortable AC seating."
    },
    {
      "name": "Luxury Force Urbania Bus Ashtavinayak Yatra from Pune",
      "description": "Luxury Force Urbania bus for Ashtavinayak Yatra from Pune with plush interiors, AC comfort, and professional chauffeur service."
    },
    {
      "name": "Urbania Bus Rental Pune for Ashtavinayak Darshan Tour",
      "description": "Complete Urbania bus rental service from Pune for Ashtavinayak Darshan tours, including one-day, two-day, and three-day packages."
    }
  ],
  "tableData": [
    ["Pune to Ashtavinayak Darshan Urbania bus hire", "Urbania bus hire for Ashtavinayak Darshan from Pune"],
    ["Force Urbania bus Pune to Ashtavinayak", "Urbania bus on rent Pune to Ashtavinayak Darshan"],
    ["13 seater Urbania bus Pune to Ashtavinayak", "17 seater Urbania bus Pune to Ashtavinayak"],
    ["Luxury Urbania bus for Ashtavinayak Darshan", "AC Urbania bus Pune Ashtavinayak tour"],
    ["Force Urbania 17 seater bus Ashtavinayak", "Urbania bus hire for Ashtavinayak Yatra Pune"],
    ["Urbania bus rental Pune for Ganpati Darshan", "Urbania bus Ashtavinayak pilgrimage tour"],
    ["Urbania bus hire Pune for temple tour", "Urbania bus for senior citizen Ashtavinayak Darshan"],
    ["Pune to Ashtavinayak Darshan bus package", "Pune Ashtavinayak 2 days Urbania bus"],
    ["Pune Ashtavinayak 3 days Urbania bus tour", "Ashtavinayak Darshan bus hire Pune itinerary"],
    ["Pune to all 8 Ganpati Darshan Urbania bus", "Ashtavinayak Darshan Urbania bus from Pune"],
    ["Book Urbania bus Pune to Ashtavinayak", "Online Urbania bus booking Ashtavinayak"],
    ["Urbania bus Pune Ashtavinayak contact number", "13 Seater Urbania Bus Pune to Ashtavinayak Darshan"],
    ["Luxury Force Urbania Bus Ashtavinayak Yatra from Pune", "Urbania Bus Rental Pune for Ashtavinayak Darshan Tour"]
  ],




"whychoose": [
  {
    "WhyChooseheading": "Convenient Urbania Hire from Pune to Ashtavinayak",
    "WhyChoosedescription": "Amruta Travels offers Pune to Ashtavinayak Darshan Urbania Hire, providing a comfortable, reliable, and stylish way for groups and families to visit the famous Ashtavinayak temples."
  },
  {
    "WhyChooseheading": "Ideal for Pilgrimage and Group Travel",
    "WhyChoosedescription": "Whether it’s a family trip, group pilgrimage, or religious tour, our Urbania ensures a smooth, safe, and comfortable journey from Pune to all the Ashtavinayak temples."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Interiors",
    "WhyChoosedescription": "Urbania vehicles feature plush seating, generous legroom, air conditioning, and ample luggage space, making them perfect for long-distance travel and day-long temple tours."
  },
  {
    "WhyChooseheading": "Experienced and Courteous Drivers",
    "WhyChoosedescription": "Our drivers are experienced with the Pune-Ashtavinayak route and are courteous and professional, ensuring a safe, timely, and enjoyable journey for all passengers."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "Amruta Travels provides competitive and transparent pricing for Pune to Ashtavinayak Urbania hires, giving you excellent value without hidden charges."
  },
  {
    "WhyChooseheading": "Clean, Well-Maintained, and Sanitized Vehicles",
    "WhyChoosedescription": "All our Urbania vehicles are regularly serviced, cleaned, and sanitized to maintain the highest standards of comfort, safety, and hygiene during the pilgrimage."
  },
  {
    "WhyChooseheading": "Flexible Pickup, Drop-Off, and Route Options",
    "WhyChoosedescription": "We offer flexible pickup and drop-off locations and customizable routes for Pune to Ashtavinayak Darshan, so your journey is convenient and stress-free."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking with Full Support",
    "WhyChoosedescription": "Booking an Urbania for Pune to Ashtavinayak Darshan is easy with Amruta Travels. Our support team assists you at every step to ensure a smooth travel experience."
  }
]

    }

const faqData = [
  {
    question: 'How can I book an Urbania from Pune to Ashtavinayak Darshan?',
    answer: 'You can book an Urbania for Pune to Ashtavinayak Darshan by contacting Amruta Travels online, via phone, or visiting our office. Our team will guide you through the booking process.'
  },
  {
    question: 'Is Urbania suitable for long-distance trips to Ashtavinayak temples?',
    answer: 'Yes, Urbania is ideal for long-distance pilgrimage trips, offering spacious seating, air conditioning, and comfort for a full-day temple tour from Pune.'
  },
  {
    question: 'Can I customize the Pune to Ashtavinayak Darshan route?',
    answer: 'Absolutely! We provide flexible routes for the pilgrimage, ensuring you visit all desired Ashtavinayak temples according to your schedule.'
  },
  {
    question: 'Does the Urbania hire include a driver?',
    answer: 'Yes, every Urbania hire includes a professional and experienced driver familiar with the Pune-Ashtavinayak route for a safe and smooth journey.'
  },
  {
    question: 'Are the Urbania vehicles well-maintained?',
    answer: 'Yes, all our Urbania vehicles are regularly serviced, cleaned, and sanitized to ensure passenger comfort, hygiene, and safety during the trip.'
  },
  {
    question: 'What is the cost of hiring Urbania for Pune to Ashtavinayak Darshan?',
    answer: 'The cost depends on distance, duration, and specific travel requirements. Contact Amruta Travels for a customized and transparent quote.'
  },
  {
    question: 'Can I get multiple pickup and drop-off points for the pilgrimage?',
    answer: 'Yes, we offer flexible pickup and drop-off options and route customization to make your Pune to Ashtavinayak Darshan convenient.'
  },
  {
    question: 'Why choose Amruta Travels for Pune to Ashtavinayak Urbania hire?',
    answer: 'Amruta Travels provides well-maintained Urbania vehicles, experienced drivers, transparent pricing, and reliable support to ensure a safe, comfortable, and hassle-free pilgrimage.'
  }
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Sunil Shinde',
    role: 'Pilgrim, Pune',
    text: 'We hired an Urbania for Pune to Ashtavinayak Darshan. The vehicle was spacious and comfortable, and the driver made the journey smooth and safe. Excellent service by Amruta Travels!',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Rekha Patil',
    role: 'Family Traveler, Pune',
    text: 'Booked an Urbania for a group pilgrimage to Ashtavinayak. The ride was comfortable, clean, and hassle-free. Highly recommend Amruta Travels for religious trips!',
    rating: 5
  }
];






























































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ashtavinayak Darshan Urbania Bus Hire",
  "image": "https://bushireinpune.com/assets/images/urbania-ashtavinayak.jpg",
  "description": "Book 13 & 17 seater Force Urbania buses from Pune for Ashtavinayak Darshan tours. Luxury and AC options available for family trips, senior citizens, and multi-day pilgrimage tours across all 8 Ganpati temples.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7500",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/pune-to-ashtavinayak-urbania"
  }
};




    return (
        <div>


<Helmet>
  <title>Call: +91 7353109555 | Pune to Ashtavinayak Darshan Urbania Bus Hire | Force Urbania Rental</title>
  <meta
    name="description"
    content="Hire 13 & 17 seater Force Urbania buses from Pune for Ashtavinayak Darshan. Luxury & AC buses available for family trips, senior citizens & multi-day Ganpati temple tours."
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/123.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetoashtavinayakdarshanurbania;